// extracted by mini-css-extract-plugin
module.exports = {"component":"NetworkHeader_component__2sy16"};